import {
	type AppWorkingHours,
	DAYS,
	getInitials
} from 'components/molecules/dateSelection'
import { workspaceApi } from 'features/workspace'
import { useEffect, useMemo, useRef, useState } from 'react'

import { getHoursInterval } from './utils'

function useEditMode({ hours, setHours }: ReturnType<typeof useHours>) {
	const [isEdit, setIsEdit] = useState(false)
	const saved = useRef<AppWorkingHours>(hours)

	const handlers = useMemo(
		() => ({
			cancelEdit: () => {
				setIsEdit(false)
				setHours(saved.current)
			},
			tornOff: () => setIsEdit(false),
			turnOn: (hours: AppWorkingHours) => {
				saved.current = hours
				setIsEdit(true)
			}
		}),
		[setHours]
	)

	return { ...handlers, isEdit }
}

function useHours() {
	const [hours, setHours] = useState(getInitials)

	const { data, isSuccess } = workspaceApi.useWorkingHoursQuery()

	useEffect(() => {
		if (!isSuccess) {
			return
		}

		setHours(previousHours =>
			DAYS.reduce(
				(nextHours, day) => {
					const workingDay = data[day]
					if (workingDay.length > 0) {
						nextHours[day].isSelected = true
						nextHours[day].value = getHoursInterval(workingDay[0])
					}

					return nextHours
				},
				{ ...previousHours }
			)
		)
	}, [data, isSuccess])

	return { hours, setHours }
}

export { useEditMode, useHours }
